import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";

import { EmptyECI } from "./EmptyECI";
import { Form } from "./Form";
import { Table } from "./Table";
import { IConsultant_ECI } from "../../models/Consultant_ECI";
import { IECI } from "../../models/ECI";
import TextTransition from "react-text-transition";
import Confetti from 'react-confetti';

export interface IModel {
    open: boolean,
    singleData: IConsultant_ECI,
    tableData: IECI | undefined
}

export const ECI = (permissions: IPermissionProps) => {

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const [modal, setModal] = useState({ singleData: EmptyECI, tableData: undefined, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    const [celebrate, setCelebrate] = useState<boolean>(false);
    const [texts,setTexts] = useState<any>(["You", "Did", "It!", `${loginObj.name}`, "Todays Target Completed"]);
    const [index, setIndex] = useState(0);

    const hideDialog = () => {
        setModal({ singleData: EmptyECI, tableData: undefined, open: false, })
    };

    const ShowCelebration = (type: string) => {
        setTexts(["You", "Did", "It!", `${loginObj.name}`, `Todays ${type} Target Completed`]);
        setCelebrate(true); setTimeout(() => setCelebrate(false), 10000);
    }

    const colors = ["#ff595e", "green", "#edae49"];

    const springConfig: any = { stiffness: 50, damping: 30 };

    useEffect(() => {
        if (celebrate) {
            const intervalId = setInterval(
                () => setIndex((index) => index + 1),
                2000
            );
            return () => { clearTimeout(intervalId); setIndex(0) }
        }
    }, [celebrate]);

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form tableData={modal.tableData} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} ShowCelebration={ShowCelebration}></Form>}
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
            {celebrate && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    gravity={0.2}
                    numberOfPieces={3500}

                />
            )}
            <div style={{ position: "absolute", top: '50%', left: '50%', transform: " translate(-50%, -50%)" }}>
                {celebrate && (
                    <TextTransition className="m-6 " style={{ color: colors[index % colors.length], alignContent: "center" }} springConfig={springConfig}><h1 style={{ fontSize: '100px', alignContent: "center", marginLeft: "40px" }}>{texts[index % texts.length]}&#127881;</h1></TextTransition>
                )}
            </div>
        </>
    );
}
